<template>
  <div class="response-input">
    <form class="response-input__form">
      <div class="response-input__background">
        <input
          class="response-input__input"
          type="text"
          placeholder="Name"
          autocomplete="off"
          v-model="inputName"
        />
      </div>
      <div class="response-input__background">
        <input
          class="response-input__input"
          :type="isMod ? 'text' : 'text'"
          :placeholder="isMod ? 'Password' : 'Email address'"
          autocomplete="off"
          v-model="inputEmail"
        />
      </div>
      <div
        class="response-input__submit-button"
        :class="{
          'response-input__submit-button--disabled': !isValidInput,
          'response-input__submit-button--submitted': hasSubmitted
        }"
      >
        <button
          class="response-input__submit-button-btn"
          @click.prevent="submitInput"
        ></button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data: () => ({
    inputName: "",
    inputEmail: "",
    hasSubmitted: false
  }),

  props: {
    value: Object,
    isMod: Boolean
  },

  methods: {
    submitInput() {
      if (this.isValidInput && (this.isMod || !this.hasSubmitted)) {
        this.hasSubmitted = true
        this.$emit("submit")
      }
    },

    emitInput() {
      this.isMod
        ? this.$emit("input", {
            name: this.inputName,
            password: this.inputEmail
          })
        : this.$emit("input", { name: this.inputName, email: this.inputEmail })
    }
  },

  computed: {
    isValidInput() {
      return this.inputName.length > 0 && this.inputEmail.length > 0
    }
  },

  watch: {
    inputName() {
      this.emitInput()
    },
    inputEmail() {
      this.emitInput()
    }
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";

.response-input {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-bottom: 10px;
  height: auto;
  transition: transform 0.3s ease,
    width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;

  // @media screen and (max-width: $break-mobile) {
  //     width: calc(100% - 50px);
  //     height: 40px;
  // }

  &__form {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: -10px;
  }

  &__background {
    flex: 0 0 auto;
    box-sizing: border-box;
    position: relative;
    border: 1px solid transparent;
    background-color: $bleach-white;
    border-radius: 999px;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    padding: 5px 20px;
    margin: 10px 0;
    transition: border-color 0.1s linear;

    &:focus-within {
      border-color: $bleach-black;
    }

    &--filled {
    }
  }

  &__input {
    position: relative;
    width: 100%;
    height: 100%;
    font-size: 18px;
    color: $bleach-purple;
    border-style: none;
    outline: none;
    background-color: transparent;

    // @media screen and (max-width: $break-mobile) {
    //     font-size: 16px;
    // }

    &--smaller {
      width: calc(100% - 60px);
    }
  }

  &__submit-button {
    position: relative;
    width: 100px;
    height: 40px;
    border: 2px solid transparent;
    border-radius: 999px;
    background-color: $bleach-white;
    transition: background-color 0.1s linear, opacity 0.1s linear;
    cursor: pointer;

    &-btn {
      position: absolute;
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: transparent;
      background-image: url("/assets/icons/emoji_thumbs_up.png");
      background-size: 30%;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }

    &:hover {
      background-color: $bleach-black;
    }

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    @keyframes dash {
      0% {
        width: 100px;
      }
      50% {
        width: 40px;
      }
      100% {
        width: 100px;
      }
    }

    &--submitted {
      pointer-events: none;
      border: 1px solid dashed;
      animation: dash 1s ease infinite;

      .response-input__submit-button-btn {
        display: none;
      }
    }
  }

  &--submitted {
    width: 50px;
    // @media screen and (max-width: $break-mobile) {
    //     width: 40px;
    // }
  }
}
</style>
